import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { UserService } from '../user/user.service';
import { StoreRole } from '../store/store';

export const assignPrGuard: CanActivateFn = () => {
   const userService = inject(UserService);
   const router = inject(Router);

   return userService.currentUser$.pipe(
      take(1),
      map((user) => {
         if (!user) return router.parseUrl('/login');

         if (user && !user.storeId && !user.isAdmin) {
            router.navigate(['/store']);
            return false;
         }

         if (user.canAssignPR) {
            return true;
         }

         console.warn(`[AssignPrGuard] Denied`);
         return router.parseUrl('/access-denied');
      }),
   );
};
